import MenuItem from "@components/molecules/MenuItem";
import { useSearchGroupSlice } from "@redux/slices/searchGroupsSlice";
import { DefaultSearchGroupProps, MenuItemProps } from "../types";
import { useTheme } from "styled-components/native";
import LineViewContainer from "@scenes/requests/utils/LineView";
import styled from "styled-components/native";
import React from "react";
import { actionFunctions, rightIconFunction } from "../utils";
import { useOtherSearchGroupSlice } from "@redux/slices/otherSearchGroups";
import { View } from "@gluestack-ui/themed";
import { itemRightTextFunction } from "./GenerateGroupName";

const SectionContainer = ({ data }: DefaultSearchGroupProps) => {
  const theme = useTheme();
  const { selectedGroups } = useSearchGroupSlice();
  const { otherGroups } = useOtherSearchGroupSlice();

  const updatedTabOptions = data.filter((item) => {
    const key = item.key;
    return (
      otherGroups[key] &&
      otherGroups[key].length > 0 &&
      !(otherGroups[key].length === 1 && otherGroups[key][0] === 0)
    );
  });

  return (
    <>
      <MenuItemContainer>
        {updatedTabOptions.map((item: MenuItemProps, index: number) => (
          <React.Fragment key={`${index}-${item.action}`}>
            <MenuItem
              {...item}
              onPress={() =>
                actionFunctions(
                  item.action,
                  otherGroups.diamond,
                  otherGroups.lab_grown_diamond,
                  otherGroups.gemstone,
                  otherGroups.jewelry
                )
              }
              itemRightText={itemRightTextFunction(
                item.itemRightText,
                selectedGroups,
                otherGroups
              )}
              rightIconTheme={rightIconFunction(
                item.rightIconTheme,
                otherGroups.diamond,
                otherGroups.lab_grown_diamond,
                otherGroups.gemstone,
                otherGroups.jewelry,
                theme
              )}
            />
            {index !== data.length - 1 && (
              <LineViewContainer background="core-02" marginLeft={true} />
            )}
          </React.Fragment>
        ))}
      </MenuItemContainer>
    </>
  );
};

const MenuItemContainer = styled(View)`
  background-color: ${({ theme }) => theme["core-01"]};
  border-radius: 10px;
`;
export default SectionContainer;
